import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Cell, Pie, PieChart, ResponsiveContainer, Sector } from 'recharts'

const metadata = {
  "smartwatch": { "color": "#FF9999" },
  "proximity": { "color": "#0C3B22" },
  "ai_detection": {"color": "#9999FF" },
  "gas_detector": { "color": "#C48F12" },
  "flood_sensor": { "color": "#6B2161" },
  "smart_lock": { "color": "#3254A8" },
  "confined_space": { "color": "#8FC412" }
}

const renderActiveShape = (props) => {
  const RADIAN = Math.PI / 180
  const { cx, cy, midAngle, innerRadius, outerRadius, startAngle, endAngle, fill, payload } = props
  const sin = Math.sin(-RADIAN * midAngle)
  const cos = Math.cos(-RADIAN * midAngle)
  const sx = cx + (outerRadius + 10) * cos
  const sy = cy + (outerRadius + 10) * sin
  const mx = cx + (outerRadius + 30) * cos
  const my = cy + (outerRadius + 30) * sin
  const ex = mx + (cos >= 0 ? 1 : -1) * 22
  const ey = my
  const textAnchor = cos >= 0 ? 'start' : 'end'

  return (
    <g>
      <text x={cx} y={cy} dy={0} textAnchor="middle" fill={fill}>
        {payload.name}
      </text>
      <text x={cx} y={cy} dy={16} textAnchor="middle" fill={fill}>
        {`Count: ${payload.value}`}
      </text>
      <Sector
        cx={cx} cy={cy} innerRadius={innerRadius} outerRadius={outerRadius}
        startAngle={startAngle} endAngle={endAngle} fill={fill}
      />
      <Sector
        cx={cx} cy={cy} startAngle={startAngle} endAngle={endAngle}
        innerRadius={outerRadius + 6} outerRadius={outerRadius + 10} fill={fill}
      />
    </g>
  )
}

const SummaryPieChart = ({ data, projectModules }) => {
  const { t } = useTranslation()

  const [activeIndex, setActiveIndex] = useState(null)

  const onPieEnter = (_, index) => {
    setActiveIndex(index)
  }

  return (
    <div style={{ width: "100%", height: "400px" }}>
      <ResponsiveContainer width="100%" height="100%">
        <PieChart width="100%" height="100%">
          <Pie
            dataKey="value"
            isAnimationActive={true}
            data={data}
            cx="50%"
            cy="50%"
            innerRadius={80}
            outerRadius={100}
            fill="#8884d8"
            activeIndex={activeIndex}
            activeShape={renderActiveShape}
            onMouseEnter={onPieEnter}
          >
            {Object.entries(metadata).map(([k, v]) => <>
              {(projectModules.includes(k)) && <>
                <Cell key={k} fill={v["color"]} />
              </>}
            </>)}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  )
}

export default SummaryPieChart
